Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-lazy-slider');

    var $configuration, configurations = [],
        currentitemid = 0;
    var model = null;
    var wrappers = $wrappers;

    if ($wrappers.length < 1)
        return;

    if (LhApp.Context.Item.Id !== undefined && LhApp.Context.Item.Id > 0)
        currentitemid = LhApp.Context.Item.Id;

    for (var i = 0; i < $wrappers.length; i++) {
        var $wrpr = $wrappers.eq(i);

        configurations.push({
            configCode: $wrpr.data("code"),
            templateCode: $wrpr.data("template"),
            entityCode: $wrpr.data("entity"),
            itemId: currentitemid,
            nodeId: $wrpr.data("node-id"),
            nodePath: $wrpr.data("node-path"),
            htmlTemplate: $wrpr.data("html"),
            class: $wrpr.data("class"),
            detailedPager: $wrpr.data("detailed-pager")
        });

    }

    $.each($wrappers, function (i, wrpr) {
        var $this = $(wrpr);

        wrpr.loading = function loading(loading) {
            if (loading) {
                $this.addClass('x-loading');
            } else {
                $this.removeClass('x-loading');
            };
        };

        wrpr.update = function update() {
            wrpr.loading(true);

            model.class = configurations[0].class;
            model.detailedPager = configurations[0].detailedPager;
            model.banners = model.HtmlBoxData;

            var html = Vendd.Handlebars.parse(configurations[0].htmlTemplate, model);
            wrpr.bind(html);

            Vendd.MessageBus.publish(wrpr, new Vendd.Widget.Messages.BindControl($(wrpr)));
            wrpr.loading(false); 
        };

        wrpr.bind = function bind(html) {
            $this.html(html);
            var lazySliderTemplate = configurations[0].htmlTemplate;

            if (lazySliderTemplate == "slider_A")

                var hpMainSlider = new Swiper(".home-page .homepage-slider", {
                    slidesPerView: 1,
                    autoHeight: true,
                    rewind: true,
                    fadeEffect: {
                        crossFade: true
                    },
                    effect: 'fade',
                    watchSlidesProgress: true,
                    keyboard: { enabled: true },
                    speed: 1000,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '">' + $('.home-page .homepage-slider .swiper-slide').eq(index).attr("data-pager") + '</span>';
                        },
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });

            hpMainSlider.on('slideChange', function () {
                var $currentSlide = $(".homepage-slider > ul > li[data-index='" + this.previousIndex + "']");
                var hasVideo = $('.video-slide', $currentSlide).length > 0;
                var videoInitialized = $('iframe', $currentSlide).length > 0;

                if (hasVideo && videoInitialized) {
                    var YTvideo = YT.get($('iframe', $currentSlide).attr('id'));
                    //pause video
                    YTvideo.pauseVideo();
                }
            });

        };
    });

    Vendd.MessageBus.subscribe(Vendd.LazyHtmlArea.Messages.LazyHtmlAreaSuccess, wrappers.get(0), function (envelope) {

        if (envelope.message.data.sender !== wrappers.get(0)) return;

        var innerWrapper = wrappers.get(0);
        var config = configurations[0];

        if (innerWrapper) {
            model = envelope.message.data.model;
            innerWrapper.update();

            removeConfiguration(innerWrapper, config);
        }
        if (wrappers.length < 1 || configurations.length < 1) return;

        Vendd.MessageBus.publishAsync(wrappers.get(0), new Vendd.LazyHtmlArea.Messages.GetLazyHtmlArea(configurations[0]));
    });

    function removeConfiguration(innerwrapper, config) {

        if (wrappers.length > 0) {
            wrappers = wrappers.slice(1);
        }

        if (configurations.length > 0) {
            var configIndex = configurations.indexOf(config);
            configurations.splice(configIndex, 1);
        }
    };

    //keep last in component's code
    (function () {
        var defaultCallExecuted;
        function defaultCall() {
            if (Vendd.User.SessionState && !defaultCallExecuted) {
                defaultCallExecuted = true;
                Vendd.MessageBus.publishAsync(wrappers.get(0), new Vendd.LazyHtmlArea.Messages.GetLazyHtmlArea(configurations[0]));
            }
        }
        defaultCall();
        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, wrappers.get(0), function (envelope) {
            defaultCall();
        });
    })();

});